import type {
    IExtProduceType,
    IExtProduceTypeVariety,
} from "@agrigate/product-catalog-types";
import type { MaybeN } from "@agrigate/ts-utils/lib/types";
import type { FlexProps } from "@chakra-ui/react";
import { Flex, Link, Text } from "@chakra-ui/react";
import ColorDot from "./ColorDot";

export default function ProductLabel(p: {
    produceType?: MaybeN<Partial<IExtProduceType>>;
    variety?: MaybeN<Partial<IExtProduceTypeVariety>>;
    containerProps?: FlexProps;
}) {
    return (
        <Flex alignItems="center" gap={4} pl={4} {...p.containerProps}>
            <ColorDot color={p.produceType?.color} />
            <Flex alignItems="flex-start" direction="column">
                <Link
                    fontSize={"xs"}
                    fontWeight={500}
                    target="_blank"
                    href={`/produces-and-categories/hub?tab=produce-types&ptId=${p.produceType?.id}`}
                >
                    <Text color={"blue.600"}>
                        {p.produceType?.name ?? p.produceType?.key}
                    </Text>
                </Link>
                <Text fontSize={"xs"} fontWeight={400}>
                    {p.variety?.name}
                </Text>
            </Flex>
        </Flex>
    );
}
